import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getFirstPermissionRoute } from '../../utils/roleUtils';

const DefaultRoute = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getFirstPermissionRoute(user)} replace />;
};

export default DefaultRoute;
